"use strict";
/**
 * Moderation `pdf` canonical template — single source of truth for the
 * `moderation-pdf` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY (setup lambda registers; moderation-history
 * reads by alias), have NO search-document interface, and are NOT read by application
 * search queries — so they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants, no
 * interface). Field types ported VERBATIM from the setup lambda's inline
 * `moderation-pdf` block. No analyzers (plain mappings), so `settings.analysis` is
 * OMITTED. `scan_details` stays UNMAPPED — handled by `dynamic: true`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationPdfTemplate = buildModerationPdfTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-pdf` family. */
function buildModerationPdfTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    pattern_id: { type: 'keyword' },
                    identity_id: { type: 'keyword' },
                    pdf_hash: { type: 'keyword' },
                    content_type: { type: 'keyword' },
                    scan_result: { type: 'keyword' },
                    severity: { type: 'keyword' },
                    status: { type: 'keyword' },
                    outcome: { type: 'keyword' },
                    resolved_by: { type: 'keyword' },
                    created_at: { type: 'date' },
                    resolved_at: { type: 'date' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-pdf' },
    };
}
